import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/@smartBanner/components/AppBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
